// src/com/tsr/TransPlanTsrViewSupplyFresh.js
import React from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { TableContainer, Table, TableHead, TableBody, TableCell, TableRow } from '@mui/material';
import { AppWord, AppStyle } from '../../value/AppConst';
import { transPlanTsrItemRepo } from '../../value/AppModel';
import { useReactiveVar } from '@apollo/client';
import { NumberCell } from '../../common/TopStyle';


const TitleCellBg = '#c5f0e9';

const TemperTitleCell = styled(TableCell)({
    backgroundColor: '#e3fffd',
    color: AppStyle.PrimaryRGB,
    fontWeight: 'bold',
    textAlign: 'center',
});

const TitleCell = styled(TableCell)({
    backgroundColor: TitleCellBg,
    color: AppStyle.PrimaryRGB,
    fontWeight: 'bold',
    textAlign: 'center',
});

const WoodTitleCell = styled(TableCell)({
    backgroundColor: '#e0e3ca',
    color: AppStyle.PrimaryRGB,
    fontWeight: 'bold',
    textAlign: 'center',
});

const SubTitleCell = styled(TableCell)({
    backgroundColor: TitleCellBg,
    fontWeight: 'bold',
    textAlign: 'center',
});

const WORD_OFF = 'off';

/**
 * 신선 물류집기 뷰어
 * PC version: TransPlanTsrEditSupplyFresh
 * @returns 
 */
export default function TransPlanTsrViewSupplyFresh() {
    const item = useReactiveVar(transPlanTsrItemRepo);

    return(
        <Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TemperTitleCell rowSpan={2} size={AppWord.SMALL}>&nbsp;</TemperTitleCell>
                            <TemperTitleCell rowSpan={2} size={AppWord.SMALL}>온도</TemperTitleCell>
                            <TitleCell colSpan={2} size={AppWord.SMALL}>Pallet</TitleCell>
                            <TitleCell colSpan={2} size={AppWord.SMALL}>Shroud</TitleCell>
                            <TitleCell colSpan={2} size={AppWord.SMALL}>기타</TitleCell>
                        </TableRow>
                        <TableRow>
                            <SubTitleCell size={AppWord.SMALL}>KPP</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>AJU</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>Full</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>Half</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>KPP</SubTitleCell>
                            <SubTitleCell size={AppWord.SMALL}>AJU</SubTitleCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TemperTitleCell>전면</TemperTitleCell>
                            <TableCell style={{textAlign:'center'}}>{item.tempF || WORD_OFF}</TableCell>
                            <NumberCell>{item.fFPalKpp}</NumberCell>
                            <NumberCell>{item.fFPalAju}</NumberCell>
                            <NumberCell>{item.fFShrFull}</NumberCell>
                            <NumberCell>{item.fFShrHalf}</NumberCell>
                            <NumberCell>{item.fFEtcKpp}</NumberCell>
                            <NumberCell>{item.fFEtcAju}</NumberCell>
                        </TableRow>
                        <TableRow>
                            <TemperTitleCell>중면</TemperTitleCell>
                            <TableCell style={{textAlign:'center'}}>{item.tempM || WORD_OFF}</TableCell>
                            <NumberCell>{item.fMPalKpp}</NumberCell>
                            <NumberCell>{item.fMPalAju}</NumberCell>
                            <NumberCell>{item.fMShrFull}</NumberCell>
                            <NumberCell>{item.fMShrHalf}</NumberCell>
                            <NumberCell>{item.fMEtcKpp}</NumberCell>
                            <NumberCell>{item.fMEtcAju}</NumberCell>
                        </TableRow>
                        <TableRow>
                            <TemperTitleCell>후면</TemperTitleCell>
                            <TableCell style={{textAlign:'center'}}>{item.tempR || WORD_OFF}</TableCell>
                            <NumberCell>{item.fRPalKpp}</NumberCell>
                            <NumberCell>{item.fRPalAju}</NumberCell>
                            <NumberCell>{item.fRShrFull}</NumberCell>
                            <NumberCell>{item.fRShrHalf}</NumberCell>
                            <NumberCell>{item.fREtcKpp}</NumberCell>
                            <NumberCell>{item.fREtcAju}</NumberCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <Box style={{height:20}}></Box>
            <Table style={{maxWidth:600}}>
                <TableHead>
                    <TableRow>
                        <WoodTitleCell>NJC</WoodTitleCell>
                        <WoodTitleCell>우든칼라</WoodTitleCell>
                        <WoodTitleCell>옥타곤</WoodTitleCell>
                        <WoodTitleCell>싱글트레이</WoodTitleCell>
                    </TableRow>
                </TableHead>
                <TableBody style={{backgroundColor: '#f9fff9'}}>
                    <TableRow>
                        <NumberCell>{item.fNjc}</NumberCell>
                        <NumberCell>{item.fUcolor}</NumberCell>
                        <NumberCell>{item.fOctagon}</NumberCell>
                        <NumberCell>{item.fTray}</NumberCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Box>
    );
}
